import { render, staticRenderFns } from "./CustomerDetailsProfile.vue?vue&type=template&id=68398c6a"
import script from "./CustomerDetailsProfile.vue?vue&type=script&lang=js"
export * from "./CustomerDetailsProfile.vue?vue&type=script&lang=js"
import style0 from "./CustomerDetailsProfile.vue?vue&type=style&index=0&id=68398c6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports